import { useGameStore } from '@hollowveil/shared';

export function WorldTransition() {
  const { isTransitioning, currentWorld } = useGameStore();

  const targetWorld = currentWorld === 'real' ? 'spectral' : 'real';

  return (
    <div
      className={`world-transition ${isTransitioning ? 'active' : ''} to-${targetWorld}`}
    />
  );
}
